// console.log('Script: plugins.js');

/**
 * jQuery Unveil
 * A very lightweight jQuery plugin to lazy load images
 * http://luis-almeida.github.com/unveil
 *
 * Licensed under the MIT license.
 * Copyright 2013 Luís Almeida
 * https://github.com/luis-almeida
 */

;(function($) {

    $.fn.unveil = function(threshold, callback) {

        var $w = $(window),
            th = threshold || 0,
            retina = window.devicePixelRatio > 1,
            attrib = retina? "data-src-retina" : "data-src",
            images = this,
            loaded;

        this.one("unveil", function() {
            var source = this.getAttribute(attrib);
            source = source || this.getAttribute("data-src");
            if (source) {
                this.setAttribute("src", source);
                if (typeof callback === "function") callback.call(this);
            }
        });

        function unveil() {
            var inview = images.filter(function() {
                var $e = $(this);
                if ($e.is(":hidden")) return;

                var wt = $w.scrollTop(),
                    wb = wt + $w.height(),
                    et = $e.offset().top,
                    eb = et + $e.height();

                return eb >= wt - th && et <= wb + th;
            });

            loaded = inview.trigger("unveil");
            images = images.not(loaded);
        }

        $w.on("scroll.unveil resize.unveil lookup.unveil", unveil);

        unveil();

        return this;

    };

})(window.jQuery || window.Zepto);

// console.log('Script: magazine-reader.js');

class MagazineReader {

    constructor(url) {
        this.pdfUrl = url;

        this.pdf = null;

        this.btnNext = null;
        this.btnPrev = null;

        this.btnMaximize = null;
        this.btnMinimize = null;

        this.wrapper = null;
        this.canvas = null;
        this.context = null;

        this.actualPage = 1;
        this.numPages = 0;

        if (this.checkRequired() && this.pdfUrl) this.init()
    }

    checkRequired() {
        return typeof pdfjsLib !== "undefined";
    }

    renderPdfPage(page) {
        this.pdf.getPage(page).then((page) => {
 
            var viewport = page.getViewport(1);
            var originalViewport = page.getViewport(1);

            if (viewport.height > viewport.width) {
                viewport = page.getViewport((this.wrapper.outerHeight() / viewport.height) * 0.9);
                this.canvas.height = viewport.height;
                this.canvas.width = viewport.width;
            } else {
                viewport = page.getViewport((this.wrapper.outerWidth() / viewport.width) * 0.9);

                if (viewport.height > this.wrapper.outerHeight()) {
                    viewport = page.getViewport((this.wrapper.outerHeight() / originalViewport.height) * 0.9);
                    this.canvas.height = viewport.height;
                    this.canvas.width = viewport.width;
                } else {
                    this.canvas.height = viewport.height;
                    this.canvas.width = viewport.width;
                }
                
            }

            page.render({
                canvasContext: this.context,
                viewport: viewport
            });

        });
    }

    loadPdf() {
        pdfjsLib.getDocument(this.pdfUrl).then((pdf) => {
            this.pdf = pdf;
            this.numPages = pdf._pdfInfo.numPages;

            this.renderPdfPage(this.actualPage);
        });
    }

    nextPage() {
        if (this.actualPage + 1 > this.numPages) return;
        this.actualPage++;
        this.renderPdfPage(this.actualPage);
    }

    prevPage() {
        if (this.actualPage - 1 === 0) return;
        this.actualPage--;
        this.renderPdfPage(this.actualPage);
    }

    setCanvasSize() {
        this.canvas.width = this.wrapper.width();
        this.canvas.height = this.wrapper.height();
    }

    maximize() {
        this.wrapper.addClass('maximize');
        setTimeout(() => this.renderPdfPage(this.actualPage))
    }

    minimize() {
        this.wrapper.removeClass('maximize');
        setTimeout(() => this.renderPdfPage(this.actualPage))
    }

    init() {
        this.btnNext = $('#magazine-next');
        this.btnPrev = $('#magazine-prev');

        this.btnNext.on('click', () => this.nextPage());
        this.btnPrev.on('click', () => this.prevPage());

        this.btnMaximize = $('#magazine-maximize');
        this.btnMinimize = $('#magazine-minimize');

        this.btnMaximize.on('click', () => this.maximize());
        this.btnMinimize.on('click', () => this.minimize());

        this.wrapper = $('#magazine-wrapper');

        this.canvas = document.getElementById('magazine-viewer');
        this.context = this.canvas.getContext('2d');

        this.setCanvasSize();

        $(window).on('resize', () => {
            this.setCanvasSize();
            setTimeout(() => this.renderPdfPage(this.actualPage), 50)
        });

        this.loadPdf();
    }

}

/*if (typeof magazinePdfUrl !== "undefined") new MagazineReader(magazinePdfUrl);*/
// console.log('Script: custom-scripts.js');

class MagazineController {

    constructor(pdfUrl) {
        this.pdfUrl = pdfUrl;
        this.$modalEl = $('#magazinePdfDetail');
        return this;
    }

    openModal() {
        this.$modalEl.find('.read-magazine-object').attr('data', this.pdfUrl);
        this.$modalEl.find('.read-magazine-embed').attr('src', this.pdfUrl);
        this.$modalEl.modal('show');
        // https://mestskadivadlaprazska.preview.nux.cz/content/files/Products/product_810/MODERNI_DIVADLO_1_2018-1539676040.pdf#view=fitH
    }

    init() {
        if (!this.pdfUrl || this.pdfUrl === "") return false;
        $("#read-magazine").on('click', (e) => {
            e.preventDefault();
            this.openModal();
        });
        return this;
    }

}


class NewsletterFormController {

    constructor($form) {
        this.form = $form;
        this.errorBox = this.form.find('#newsletter-form-errors');
        this.successBox = this.form.find('#newsletter-form-success');

        this.initEvents();
        return this;
    }

    onSuccess() {
        this.successBox.text('Registrace proběhla úspěšně');
        this.form[0].reset();
    }

    onErrorMessage(data) {
        this.setError(data.message.username);
    }

    setError(msg) {
        this.errorBox.text(msg);
    }

    validate() {
        if (this.form.find('#mfee09input_username').val() === "") {
            this.setError('Nejprve vyplňte váš e-mail');
            return false;
        }

        if (!this.form.find('#newsletter-rules').is(':checked')) {
            this.setError('Musíte souhlasit se zásadami ochrany osobních údájů');
            return false;
        }

        this.setError('');

        return true;
    }

    onSubmit() {

        if (!this.validate()) return;

        $.ajax({
            type: "POST",
            url: this.form.attr('action'),
            data: this.form.serialize(),
            success: (data) => {
                if (typeof data === "string") this.onSuccess();
                else if (data.error) this.onErrorMessage(data);
            }
        });
    }

    initEvents() {
        this.form.on('submit', (e) => {
            e.preventDefault();
            this.onSubmit()
        })
    }

}

class NewsletterFormskolyController {

    constructor($form) {
        this.form = $form;
        this.errorBox = this.form.find('#newsletter-form-errors');
        this.successBox = this.form.find('#newsletter-form-success');

        this.initEvents();
        return this;
    }

    onSuccess() {
        this.successBox.text('Registrace proběhla úspěšně');
        this.form[0].reset();
    }

    onErrorMessage(data) {
        this.setError(data.message.username);
    }

    setError(msg) {
        this.errorBox.text(msg);
    }

    validate() {

        if (this.form.find('#m06a1finput_username').val() === "") {
            this.setError('Nejprve vyplňte váš e-mail');
            return false;
        }

        if (!this.form.find('#newsletterskoly-rules').is(':checked')) {
            this.setError('Musíte souhlasit se zásadami ochrany osobních údájů');
            return false;
        }

        this.setError('');

        return true;
    }

    onSubmit() {

        if (!this.validate()) return;

        $.ajax({
            type: "POST",
            url: this.form.attr('action'),
            data: this.form.serialize(),
            success: (data) => {
                if (typeof data === "string") this.onSuccess();
                else if (data.error) this.onErrorMessage(data);
            }
        });
    }

    initEvents() {
        this.form.on('submit', (e) => {
            e.preventDefault();
            this.onSubmit()
        })
    }

}

// class ExampleClass {
//
//     constructor() {
//        this.name = 'Martin';
//
//         return this;
//     }
//
//     static hello(name) {
//         alert(`Hello ${name}`);
//     }
//
//     init() {
//         ExampleClass.hello(this.name);
//
//         return this;
//     }
//
// }
//

// console.log('Script: custom-collapse.js');

class CustomCollapse {

    constructor($buttons) {
        this.$buttons = $buttons;

        this.initEvents();

        return this;
    }

    static toggle(target) {
        $(target).toggleClass('custom-collapse-in');
    }

    initEvents() {
        this.$buttons.on('click', function (e) {
            e.preventDefault();
            CustomCollapse.toggle($(this).data('target') || $(this).attr('href'));
        })
    }

}
// console.log('Script: data-search.js');

/**
 * Data attr search
 */ 

class DataSearch {
    constructor($input, $emptyElement, attr) {
        this.$input = $input;
        this.attr = attr || 'data-search';
        this.$emptyElement = $emptyElement;
        this.$items =  null;

        this.init();
    }

    showNoItemsMessage() {
        if (this.$emptyElement || this.$emptyElement[0]) this.$emptyElement.show()
    }

    hideNoItemsMessage() {
        if (this.$emptyElement || this.$emptyElement[0]) this.$emptyElement.hide()
    }

    reset() {
        this.$items.show();
        this.$input.val("")
    }

    filter(val) {
        let counter = 0;
        this.$items.each(function () {
            if ($(this).data('search').toLowerCase().indexOf(val) === -1) {
                counter++;
                $(this).hide();
            } else {
                $(this).show();
            }
        });

        if (this.$items.length === counter) {
            this.showNoItemsMessage()
        } else {
            this.hideNoItemsMessage()
        }

    };

    search() {
        if (this.$input.val() === "") {
            this.reset()
        } else {
            this.filter(this.$input.val().toLowerCase())
        }
    }
    
    init() {
        if (!this.$input[0]) return;
        this.$items = $(`[${this.attr}]`);
        if (!this.$items[0]) return;
        this.$input.on('keyup blur', () => this.search())
    }
}
// console.log('Script: scroll-up.js');

/**
 * Ovládání scroll up buttonu
 */

class ScrollUp {
    constructor($btn) {
        this.$btn = $btn;
        this.active = false;

        this.init();
    }

    show() {
        this.$btn.fadeIn();
        this.active = true;
    }

    hide() {
        this.$btn.fadeOut();
        this.active = false;
    }

    init() {
        if (!this.$btn[0]) return;
        let $w = $(window);

        this.$btn.on('click', () => $('html, body').animate({'scrollTop': 0}, 800));

        $w.on('scroll', (e) => {
            if ($w.scrollTop() > 3000 && !this.active) {
                this.show();
            } else if ($w.scrollTop() <= 3000 && this.active) {
                this.hide();
            }
        })
    }

}
// console.log('Script: alphabetical-sort.js');

/**
 * Web page sliders
 */
class AlphabeticalSort {

    constructor($container) {
        this.$container =  $container;
        this.$btn = this.$container.find('.alphabetical-sort-btn');
        this.$btnCancel = this.$container.find('.alphabetical-sort-btn-cancel');

        this.targetSelector = 'data-alphabetical-sort';

        this.$btnCancel.css("opacity", 0);

        this.init();
    }

    reset() {
        $(`[${this.targetSelector}]`).show();
        this.$btn.removeClass('active');
        this.$btnCancel.css("opacity", 0);
    }

    setSort(char) {
        $('.alphabetical-sort-item').show().not(`[${this.targetSelector}='${char}']`).hide();
        this.$btn.removeClass('active');

        this.$btn.removeClass('active').filter(function() {
            return $(this).text() === char;
        }).addClass('active');

        this.$btnCancel.css("opacity", 1);
    }

    sort(char) {
        if (!char || char === "zrušit") {
            this.reset();
        } else {
            this.setSort(char)
        }
        if (repertoireSearch) repertoireSearch.$input.val("");
        $(window).trigger("lookup");
    }

    init() {
        if (!this.$container[0]) return false;

        let scope = this;

        this.$btn.on('click', function () {
            scope.sort($(this).text().toLocaleLowerCase());
            console.log($(this).text().toLocaleLowerCase());
        })
    }
}
// console.log('Script: sliders.js');

/**
 * Web page sliders
 */
class Sliders {

    constructor($container) {
        this.slider = null;
        this.$container =  $container;

        this.basicOption = {
            item: 1,
            loop: false,
            controls: false,
            slideMove: 1,
            easing: 'cubic-bezier(0.25, 0, 0.25, 1)',
            speed: 600
        };

        return this;
    }

    initBasicSlider() {
        this.$container.lightSlider(this.basicOption);
    }

    initCustomSlider(option) {
        if (!option) {
            option = this.basicOption;
        } else {
            try {
                option = JSON.parse(option)
            } catch (e) {
                option = this.basicOption;
                console.log(e)
            }
        }

        this.$container.lightSlider(option);

        console.log(option);
    }

}

// console.log('Script: gallery.js');
class DynamicGallery {

    constructor() {
        this.lg = null;
    }

    static option() {
        return {
            dynamic:            true,
            dynamicEl:          [],
            thumbWidth:         140,
            videoMaxWidth:      '95%',
            loadVimeoThumbnail: false,
            download:           false
        }
    }

    static slide(index) {
        setTimeout(() => DynamicGallery.lg.data('lightGallery').slide(index));
        return this;
    }

    static init(targetSelector) {
        if (typeof targetSelector === 'undefined') return;

        DynamicGallery.lg = $(targetSelector);

        if (DynamicGallery.lg.find('div').length < 1) return;

        let option = DynamicGallery.option();

        DynamicGallery.lg.find('div').each(function() {
            let $item = $(this);
            let dynamicElement = {
                src: $item.data('src'),
                iframe: $item.data('iframe'),
                thumb: $item.data('thumb'),
                subHtml: $item.data('sub-html')
            };

            option.dynamicEl.push(dynamicElement);
        });

        DynamicGallery.lg.lightGallery(option);

        return this;
    }

}

// console.log('Script: nav.js');

/**
 * HomePage Vimeou Player
 */
class Nav {

    constructor() {

        this.$nav = $('#nav');
        this.$btn = $('#nav-button');
        this.$hdr = $('#header');

        this.activeClass = 'active';
        this.activeTiming = 400;


        this.initEvents();
    }

    isOpen() {
        return this.$nav.hasClass(this.activeClass);
    }

    open() {
        if (this.isOpen()) return;

        this.$nav.slideDown(this.activeTiming);
        this.$nav.addClass(this.activeClass);
        this.$btn.addClass(this.activeClass);
        this.$hdr.addClass(this.activeClass);
    }

    close() {
        if (!this.isOpen()) return;

        this.$nav.slideUp(this.activeTiming);
        this.$nav.removeClass(this.activeClass);
        this.$btn.removeClass(this.activeClass);
        this.$hdr.removeClass(this.activeClass);
    }

    toggle() {
        if (!this.isOpen()) this.open();
        else if (this.isOpen()) this.close();
    }

    initEvents() {
        this.$btn.on('click', () => this.toggle())
    }

}
/**
 * Search controller
 */
class Search {

    constructor()
    {

        this.$icon = $('#search-toggle');
        this.$container = $('#search-collapse');
        this.$input = this.$container.find('#search-field');
        this.$form = this.$container.find('#search-form');
        this.$loader = this.$container.find('.spinner-border');

        this.$psstContainer = this.$container.find('#psst-container');
        this.$psstItemTemplate = this.$container.find('#psst-item-template');

        if (gv.page_alias === "abc") this.$icon.removeClass('d-none');

        this.searchingTimeout = null;

        this.initEvents();
    }

    isOpen()
    {
        return this.$container.hasClass('show');
    }

    open()
    {
        if (this.isOpen()) return;
        this.$container.collapse('show');
        this.$input.focus();
    }

    close()
    {
        if (!this.isOpen()) return;
        this.$container.collapse('hide');
    }

    toggle()
    {
        if (!this.isOpen()) {
            this.open();
        } else {
            this.close();
        }
    }

    getSearchItemTemplate(type, name, link)
    {
        let $item = this.$psstItemTemplate.clone();

        $item.removeAttr('id').removeClass('d-none').addClass('d-block').attr('href', link);
        $item.find('.psst-item-type').text(type);
        $item.find('.psst-item-name').text(name);

        return $item;
    }

    setSearchResults(results) {
        if (!results || typeof results !== "object" || typeof results.count === "undefined") return;

        this.clearSearchResult();

        let $items = [];

        if (results.ensemble.length) {
            results.ensemble.forEach((prod) => {
                $items.push(this.getSearchItemTemplate('SOUBOR - ', prod.product_name, prod.url))
            })
        }

        if (results.inscenation.length) {
            results.inscenation.forEach((prod) => {
                $items.push(this.getSearchItemTemplate('REPERTOÁR - ', prod.product_name, prod.url))
            })
        }

        this.$psstContainer.append($items);

    }

    clearSearchResult()
    {
        this.$psstContainer.empty();
    }

    getSearchResults(search)
    {
        $.ajax({
            cache      : false,
            type       : "GET",
            crossDomain: true,
            url        : gv.root_url + "/ajax/search/",
            xhrFields  : { withCredentials: true },
            data       : { search },
            success    : (data) => {
                this.setSearchResults(data);
                this.searching = false;
                this.hideLoader();
            },
            error      : function (XMLHttpRequest, textStatus, errorThrown) {
                console.log('search-error', textStatus);
            }
        });
    }

    psst()
    {
        this.showLoader();
        clearTimeout(this.searchingTimeout);
        this.searchingTimeout = setTimeout(() => {
            if (!this.searching) {
                this.searching = true;
                this.getSearchResults(this.$input.val());
            }
        }, 500)
    }

    showLoader()
    {
        this.$loader.fadeIn(200);
    }

    hideLoader()
    {
        this.$loader.fadeOut(200);
    }

    initEvents()
    {
        this.$icon.on('click', () => this.toggle());
        this.$input.on('keyup', () => this.psst());
    }

}
const ID_COLOSSEUM_LINK = 'colosseum-link';
const ID_COLOSSEUM_CART = 'colosseum-cart';

class Colosseum {

    /**
     * Constructor
     *
     * @param {number} mrsId
     * @param {string} webSaleUrl
     */
    constructor(mrsId, webSaleUrl) {
        this.mrsId = mrsId;
        this.webSaleUrl = webSaleUrl;

        this.$link = $('#' + ID_COLOSSEUM_LINK);
        this.$cart = $('#' + ID_COLOSSEUM_CART);
        this.$cart.on('click', this._callbackCartClick.bind(this));
        this.$cartCount = this.$cart.find('span');

        this.authorized = false;
        this.urlAccount = this.$link.attr('href');
        this.urlCart = '#';
        this.userName = '';
        this.cartCount = 0;

        this._initData();
    }

    /**
     * Inicializace dat z Colossea
     *
     * @private
     */
    _initData() {
        // TODO: dočasné řešení pro preview
        if (APPLICATION_ENV_DEVELOPMENT) {
            $.ajax({
                cache: false,
                type: 'GET',
                crossDomain: true,
                url: 'https://www.mestskadivadlaprazska.cz/data-for-preview/',
                xhrFields: {withCredentials: true},
                dataType: 'xml',
                success: this._callbackColosseumSuccess.bind(this),
                error: this._callbakColosseumError.bind(this),
            });
            return;
        }

        let url = this.webSaleUrl + '/globalinfo';
        let data = {
            mrsid: this.mrsId,
            full : '1'
        };

        $.ajax({
            cache: false,
            type: 'GET',
            crossDomain: true,
            url: url,
            xhrFields: {withCredentials: true},
            data: data,
            dataType: 'xml',
            success: this._callbackColosseumSuccess.bind(this),
            error: this._callbakColosseumError.bind(this)
        });
    }

    /**
     * @private
     */
    _updateDOM() {
        // link
        this.$link.attr('href', this.urlAccount);
        if (this.authorized) {
            this.$link.text(this.userName);
        } else {
            let text = this.$link.data('defaulttext');
            this.$link.text(text);
        }

        // cart
        this.$cartCount.text(this.cartCount);
        if (this.cartCount) {
            this.$cart.attr('href', this.urlCart);
        } else {
            this.$cart.attr('href', '#');
        }
    }

    /**
     * @private
     */
    _callbackColosseumSuccess(xml, status) {    // možné parametry: xml, status, xhr
        if (status !== 'success') {
            return;
        }

        if (APPLICATION_ENV_DEVELOPMENT) {
            console.log('[Colosseum:globalinfo] data obtained', xml);
        }

        this.urlAccount = this.constructor._parseXmlTagValue(xml, 'orderList');
        this.urlCart = this.constructor._parseXmlTagValue(xml, 'cart');
        this.authorized = (xml.getElementsByTagName('authorized')[0].innerHTML === 'true');
        this.userName = this.constructor._parseXmlTagValue(xml, 'name');
        this.cartCount = Number(this.constructor._parseXmlTagValue(xml, 'count'));

        this._updateDOM();

        // TODO: dočasné řešení pro preview
        if (!APPLICATION_ENV_DEVELOPMENT) {
            this._setDataToCookie();
        }
    }

    /**
     * @private
     */
    _callbakColosseumError(XMLHttpRequest, textStatus) {    // možné parametry: XMLHttpRequest, textStatus, errorThrown
        // console.log('[Colosseum:globalinfo] failed', textStatus);
    }

    /**
     * Callback události kliknutí na košík
     *
     * @param {JQuery.TriggeredEvent} event
     *
     * @private
     */
    _callbackCartClick(event) {
        if (!this.cartCount) {
            event.preventDefault()
        }
    }

    /**
     * Parsuje hodnotu tagu z XML
     *
     * @param {Document} xml
     * @param {string}   tag
     *
     * @returns {string}
     *
     * @private
     */
    static _parseXmlTagValue(xml, tag) {
        return xml.getElementsByTagName(tag)[0].innerHTML;
    }

    /**
     * @private
     */
    _setDataToCookie() {
        let data = {
            authorized: this.authorized,
            urlAccount: this.urlAccount,
            urlCart: this.urlCart,
            userName: this.userName,
            cartCount: this.cartCount
        };
        data = JSON.stringify(data);
        document.cookie = `colosseumuser=${data}; path=/`;
    }

    // /**
    //  * @private
    //  */
    // _getDataFromCookie() {
    //     let search = 'colosseumuser=';
    //     let data = null;
    //     let cookies = document.cookie.split('; ');
    //     for (let i = 0; i < cookies.length; ++i) {
    //         let cookie = cookies[i];
    //         if (cookie.indexOf(search) === 0) {
    //             data = cookie.substring(search.length, cookie.length);
    //             break;
    //         }
    //     }
    //
    //     if (data) {
    //         data = JSON.parse(data);
    //     }
    //
    //     console.log(data);
    // }
}
// console.log('Script: magazine-reader.js');

class vimeoShowcase {

    constructor() {
        this.loading = true;

        this.showcaseIDs = [];

        this.$tvWrapper = $(".tv-wrapper");
        this.$loader = $(".lds-ring");
    }

    loadVideoShowcase() {
        $.ajax({
            type       : "GET",
            url        : `https://api.vimeo.com/me/albums`,
            crossDomain: true,
            headers: {
                Authorization: 'bearer 7f8d5b05ab20333327793adcee9ce684',
                Accept: 'application/vnd.vimeo.*+json;version=3.4'
            },
            success    : (data) => {
                data.data.map((showcase, index) => {
                    let reducerID = showcase.link.replace('https://vimeo.com/showcase/', '');
                    let data = {
                      id: reducerID,
                      index: index,
                      name: showcase.name
                    };

                    this.$tvWrapper.prepend(
                ` 
                        <div class="tv" data-id="${reducerID}">
                            <hr class="dashed">
                            <!--<h1 class="text-uppercase mb-3 title-h2 tv-category"></h1>-->
                            <div class="dynamic-slider"></div>
                        </div>
                       `
                    );

                    this.showcaseIDs.push(data);
                    this.loadVideosFromShowcase();
                });
            },
            error: function(err) {
                console.log('error:', err);
            },
        });
    }

    dynamicSort(property,order) {
        var sort_order = 1;
        if(order === "desc"){
            sort_order = -1;
        }
        return function (a, b){
            // a should come before b in the sorted order
            if(a[property] < b[property]){
                return -1 * sort_order;
                // a should come after b in the sorted order
            }else if(a[property] > b[property]){
                return 1 * sort_order;
                // a and b are the same
            }else{
                return 0 * sort_order;
            }
        }
    }

    loadVideosFromShowcase() {
        setTimeout(() => {
            this.showcaseIDs.map((id) => {
                $.ajax({
                    type       : "GET",
                    url        : `https://api.vimeo.com/me/albums/${id.id}/videos`,
                    crossDomain: true,
                    headers: {
                        Authorization: 'bearer 7f8d5b05ab20333327793adcee9ce684',
                        Accept: 'application/vnd.vimeo.*+json;version=3.4'
                    },
                    success    : (data) => {
                        let random;
                        let buyButton;

                        data.data.sort(this.dynamicSort("release_time","desc")).map(item => {
                            let eventid = item.tags[0].name.length === 5 ? item.tags[0].name : item.tags[1].name;
                            let inscenationId = item.tags[0].name.length === 4 ? item.tags[0].name : item.tags[1].name;
                            if (item.tags[0] !== undefined) {
                                buyButton =
                                    `
                                    <form class="buyticketslink" action="https://vstupenky.mestskadivadlaprazska.cz/incoming.aspx" method="post" target="_blank">
                                        <input type="hidden" name="mrsid" value="30">
                                        <input type="hidden" name="eventid" value="${eventid}">
                                        <input type="hidden" name="currency" value="czk">
                                        <input type="hidden" name="language" value="cs-CZ">
                                        <input type="hidden" name="successredirect" value="https://www.mestskadivadlaprazska.cz/program/">
                                        <input type="hidden" name="failedredirect" value="https://www.mestskadivadlaprazska.cz/mediateka/mdplay/">
                                        <input type="hidden" name="redirectaddtickets" value="https://www.mestskadivadlaprazska.cz/program/">
                                        <button aria-label="Koupit vstupenku" type="submit" class="min-w-10rem btn btn-main text-uppercase">koupit vstupenku</button> 
                                    </form>
                                `
                            } else {
                                buyButton = "";
                            }

                            random = Math.floor(Math.random() * 999999);
                            this.$tvWrapper.find(".tv").eq(id.index).find(".tv-category").text(id.name);
                            this.$tvWrapper.find(".tv").eq(id.index).find(".dynamic-slider").prepend(
                                ` 
                                        <div> 
                                            <div class="hover-img" data-dynamic-gallery="#dynamic-gallery-video-${random}" data-thumb="${item.pictures.sizes[4].link}" data-src="${item.link}">
                                                <div class="play-button" aria-label="Spustit video">
                                                    <svg version="1.1" focusable="false" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                                                        <path fill="#fff" d="M371.7,238l-176-107c-15.8-8.8-35.7,2.5-35.7,21v208c0,18.4,19.8,29.8,35.7,21l176-101C388.1,270.9,388.1,247.2,371.7,238z
                                                        \t M504,256C504,119,393,8,256,8S8,119,8,256s111,248,248,248S504,393,504,256z M56,256c0-110.5,89.5-200,200-200s200,89.5,200,200
                                                        \ts-89.5,200-200,200S56,366.5,56,256z"/>
                                                    </svg>
                                                </div>
                                                <img src="${item.pictures.sizes[4].link}" alt="" class="img-fluid" data-dynamic-gallery="#dynamic-gallery-video-${random}">
                                            </div>  
                                            <a href="https://www.mestskadivadlaprazska.cz/inscenace/${inscenationId}/" target="_blank" class="text-decoration-none">
                                                <h2 class="text-uppercase mt-3 mt-sm-4 mb-3">${item.name}</h2>
                                            </a>     
                                                                         
                                            ${buyButton}
                                            <p class="mt-3 pb-lg-5">${item.description || ""}</p>
                                        </div> 
                               `
                            )
                        });
                        this.loadDynamicSlider();
                    },
                    error: function(err) {
                        console.log('error:', err);
                    },
                });
            });
        }, 900);
    }

    loadDynamicSlider() {
        let dynamicSlider = this.$tvWrapper.find(".dynamic-slider").lightSlider({
            gallery:true,
            item: 3,
            adaptiveHeight: true,
            loop: false,
            autoWidth: false,
            speed: 600,
            responsive : [
                {
                    breakpoint:768,
                    settings: {
                        item:1,
                        slideMove:1,
                        pager: false
                    }
                },
            ],
            onSliderLoad: function(el) {
                el.lightGallery({
                    selector: '.hover-img',
                    fullScreen: false,
                    videoMaxWidth: '75%',
                });
            }
        });
    }

    init() {
        this.loadVideoShowcase();

        setTimeout(() => {
            this.loading = false;

            if (!this.loading) {
                this.$loader.css("opacity", "0");
                this.$tvWrapper.css("opacity", "1");
            }
         }, 1600)
    }

}

if (typeof vimeoShowcase !== "undefined" && gv.page_alias === "mdplay") {
    new vimeoShowcase().init();
}
// console.log('Script: init all');

/**
 *  Inicializace všech scriptů
 */

const MRSID = 30;
const COLOSSEUM_WEB_SALE_URL = 'https://vstupenky.mestskadivadlaprazska.cz';

const nav = new Nav();
const search = new Search();

new Colosseum(MRSID, COLOSSEUM_WEB_SALE_URL);

let $repertoireSearchInput = $('#repertoire-search');
let $alphabeticalSort = $('#alphabetical-sort');
let $scrollUpBtn = $('#scroll-up');
let $customCollapseButtons = $('[data-toggle="custom-collapse"]');
let $newsletterForm = $('#mfee09moduleform_1');
let $newsletterFormskoly = $('#m06a1fmoduleform_1');

if ($repertoireSearchInput[0]) {
    var repertoireSearch = new DataSearch($repertoireSearchInput, $('#repertoire-search-empty'));
}

if ($alphabeticalSort[0]) new AlphabeticalSort($alphabeticalSort);
if ($scrollUpBtn[0]) new ScrollUp($scrollUpBtn);
if ($customCollapseButtons[0]) new CustomCollapse($customCollapseButtons);
/*if (typeof magazinePdfUrl !== "undefined") new MagazineController(magazinePdfUrl).init();*/
if ($newsletterForm[0]) new NewsletterFormController($newsletterForm);
if ($newsletterFormskoly[0]) new NewsletterFormskolyController($newsletterFormskoly);

$(function() {

    let $basicSlider = $('.basic-slider');
    let $customSlider = $('.custom-slider');
    let $lightGallery = $(".lightGallery");

    if ($basicSlider[0]) new Sliders($basicSlider).initBasicSlider();
    if ($customSlider[0]) {
        $customSlider.each(function () {
            new Sliders($(this)).initCustomSlider($(this).data('slider-option'));
        });
    }

    $('.custom-slider2').lightSlider({
        item:3,
        loop:false,
        slideMove:3,
        slideMargin: 20,
        pager: false,
        easing: 'cubic-bezier(0.25, 0, 0.25, 1)',
        speed:600,
        responsive : [
            {
                breakpoint:768,
                settings: {
                    item:1,
                    slideMove: 1
                }
            }
        ]
    });

    $("[data-src]").unveil();

    $('[data-toggle="tooltip"]').tooltip();
    $('[data-toggle="popover"]').popover();

    $('[data-init="unveil"]').on('click', function () {
        setTimeout(function () {
            $("[data-src]").unveil();
        }, 400)
    });

    if ($lightGallery[0]) $lightGallery.lightGallery({thumbnail: true,download: false});

    $('[data-dynamic-gallery]').on('click', function () {
        DynamicGallery.init($(this).data('dynamic-gallery'));
        if ($(this).data('slide')) DynamicGallery.slide(parseInt($(this).data('slide')));
    });

});

/**
 * Click -> scroll to target
 */
$('[data-scroll-to]').on('click', function (e) {
    e.preventDefault();
    $(".default-page").trigger("click");
    $(".default-page").removeClass("active");
    $(this).addClass("active");
    let $target = $($(this).data('scroll-to'));
    setTimeout(function () {
        if (!$target[0]) return;
        $('html, body').animate({ 'scrollTop': $target.offset().top - 50 }, 800);
    }, 500);
});

// console.log('Script: analytics.js');

$('.buyticketsbutton [type="submit"], .buyticketslink [type="submit"]').click(function () {
    fbq('track', 'AddToCart');
});